import { useEffect, useRef, useState } from 'react'

const COURSEWORK = [
    'Data Structures',
    'Algorithms',
    'Operating Systems',
    'Database Systems',
    'Computer Networks',
    'Software Engineering',
    'Artificial Intelligence',
    'Machine Learning',
    'Cybersecurity',
    'Distributed Systems',
    'Cloud Computing',
    'Computer Architecture',
]

export default function TerminalCoursework() {
    const prefersReduced = typeof window !== 'undefined'
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false

    const wrapRef = useRef<HTMLDivElement>(null)
    const [revealed, setRevealed] = useState<string[]>(prefersReduced ? COURSEWORK : [])
    const [started, setStarted] = useState(false)
    const triggered = useRef(false)

    /* Trigger once on scroll into view */
    useEffect(() => {
        if (prefersReduced) return
        const el = wrapRef.current
        if (!el) return

        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !triggered.current) {
                    triggered.current = true
                    setStarted(true)
                    obs.disconnect()
                }
            },
            { threshold: 0.2 }
        )
        obs.observe(el)
        return () => obs.disconnect()
    }, [prefersReduced])

    /* Reveal lines one by one */
    useEffect(() => {
        if (!started || prefersReduced) return
        let idx = 0

        const reveal = () => {
            if (idx >= COURSEWORK.length) return
            setRevealed(prev => [...prev, COURSEWORK[idx]])
            idx++
            setTimeout(reveal, 110)
        }

        const t = setTimeout(reveal, 200)
        return () => clearTimeout(t)
    }, [started, prefersReduced])

    return (
        <div ref={wrapRef} className="mt-3 text-[10px] font-mono">
            <p className="text-primary mb-2">
                {'> '}
                <span className="text-[#888]">Loading Coursework...</span>
            </p>
            <div className="space-y-0.5 ml-4">
                {revealed.map((course, i) => (
                    <p key={i} className="text-[#666] leading-relaxed">
                        {course}
                    </p>
                ))}
            </div>
        </div>
    )
}
